import { FontStyles } from "../Font";

// eslint-disable-next-line import/prefer-default-export
export const fontStylesTokens = {
  web: FontStyles.web,
  reactNative: FontStyles.reactNative,
};
